import { groupAccountsTable } from './tables/administration/groups/groupAccountsTable.directive';
import { accountsGroupTable } from "./tables/accounts/accountsGroupTable.directive";
import { accountsSubGroupTable } from "./tables/accounts/accountsSubGroupTable.directive";
import { subGrouping } from './tables/accounts/subGrouping.directive';
import { accountsView } from './tables/accounts/accountsView.directive';
import { accountsTabListDirective } from './tables/accounts/accountsTabList.directive';
import { exportComponent } from './tables/export/exportComponent.directive';
import { groupsExportComponent } from './tables/export/groupsExportComponent.directive';
import { selectAllComponent } from './tables/uiSelectAll/selectAllComponent.directive';
import { accountInfoPanel } from './infoPanel/accountInfoPanel';
import { clearSortingDirective } from './tables/tablesCols/clearSorting/clearSorting.directive';

import { pieCharts } from './widgets/pieChartsW/pieCharts';
import { countryMap } from './widgets/countryMapW/countryMap';
import { barChart } from './widgets/barChartW/barChart';
import { reportingAccountsTable } from "./tables/administration/reporting/reportingAccountsTable.directive";

import { administrationTableMenu } from './tables/administration/administrationTableMenu';

import { erroneousStatementsTable } from "./tables/erroneousstatements/erroneousStatementsTable.directive";
import { valueSeriesGroupTable } from "./tables/valueseries/valueSeriesGroupTable.directive";
import { fsDateTimeFilter } from "../common/filters/fsDateTime";
import { fsDateTimeNoLocalFilter } from "../common/filters/fsDateTimeNoLocal";
import { fsNumberFilter } from "../common/filters/fsNumberFilter";
import { fsDateFilter } from "../common/filters/fsDate";
import { fsDateCalendarFilter } from "../common/filters/fsDateCalendar";
import { accountsPropsFilter } from "../common/filters/accountPropsFilter";

import { fsNotificationsDirective } from "./notifications/notifications.directive";

import { pieFlotChart } from './flots/pieFlotChart.directive';
import { barFlotChart } from './flots/barFlotChart.directive';
import { fsDateNoLocalFilter } from "../common/filters/fsDateNoLocal";
import { multipleSelect } from './uiSelect/multipleSelect.directive';
import { backendMultipleSelect } from './uiSelect/backendMultiSelect.directive';

export class Directives {
   /** @ngInject */
    constructor(arswebModule) {
        this.arswebModule = arswebModule;
    }

    defineDirectives() {
        this.arswebModule
            .filter('fsDateCalendar', fsDateCalendarFilter)
            .filter('accountsPropsFilter', accountsPropsFilter)
            .filter('fsNumber', fsNumberFilter)
            .filter('fsDate', fsDateFilter)
            .filter('fsDateTime', fsDateTimeFilter)
            .filter('fsDateNoLocal', fsDateNoLocalFilter)
            .filter('fsDateTimeNoLocal', fsDateTimeNoLocalFilter)
            .directive('accountsTabList', accountsTabListDirective)
            .directive('accountsGroupTable', accountsGroupTable)
            .directive('groupAccountsTable', groupAccountsTable)
            .directive('accountsView', accountsView)
            .directive('exportComponent', exportComponent)
            .directive('groupsExportComponent', groupsExportComponent)
            .directive('selectAllComponent', selectAllComponent)
            .directive('accountInfoPanel', accountInfoPanel)
            .directive('pieCharts', pieCharts)
            .directive('countryMap', countryMap)
            .directive('barChart', barChart)
            .directive('subGrouping', subGrouping)
            .directive('accountsSubGroupTable', accountsSubGroupTable)
            .directive('clearSorting', clearSortingDirective)
            .directive('reportingAccountsTable', reportingAccountsTable)
            .directive('administrationTableMenu', administrationTableMenu)
            .directive('valueSeriesGroupTable', valueSeriesGroupTable)
            .directive('erroneousStatementsTable', erroneousStatementsTable)
            .directive('fsNotifications', fsNotificationsDirective)
            .directive('pieFlotChart', pieFlotChart)
            .directive('barFlotChart', barFlotChart)
            .directive('multipleSelect', multipleSelect)
            .directive('backendMultipleSelect', backendMultipleSelect)
    }
}
